import React, { useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import { useRecentOrders } from 'hooks/useDashboard';
import { formatMoney } from 'helpers/utils';
import paths from 'routes/paths';
import dayjs from 'dayjs';

const recentDonationsColumns = [
  {
    accessor: 'simple_id',
    Header: 'Ref',
    cellProps: {
      className: 'py-2'
    },
    Cell: rowData => {
      const { id, donar_id, simple_id } = rowData.row.original;
      return <Link to={`/donors/${donar_id}/giving/${id}`}>{simple_id}</Link>;
    }
  },
  {
    accessor: 'name',
    Header: 'Donor',
    cellProps: {
      className: 'py-2'
    }
  },
  {
    accessor: 'created_at',
    Header: 'Date',
    cellProps: {
      className: 'fw-medium py-2'
    },
    Cell: rowData => {
      const { created_at } = rowData.row.original;
      return dayjs(created_at).format('DD/MM/YY');
    }
  },
  {
    accessor: 'amount',
    Header: 'Amount',
    cellProps: {
      className: 'py-2'
    },
    Cell: rowData => {
      const { amount } = rowData.row.original;
      return formatMoney(amount);
    }
  }
];

const RecentDonationsTable = ({ limit = 10 }) => {
  const navigate = useNavigate();
  const { orders, isLoading } = useRecentOrders(limit);

  const tableData = useMemo(() => {
    if (!orders) return [];

    return orders.map(order => {
      // Get primary email from donor
      let primaryEmail = '';
      if (Array.isArray(order.donar?.email)) {
        primaryEmail =
          order.donar.email?.find(email => email.isPrimary)?.email ?? '';
      } else if (typeof order.donar?.email === 'string') {
        primaryEmail = order.donar.email;
      }

      return {
        name: (
          <Link to={paths.donorDetails.replace(':id', order.donar?.id)}>
            {order.donar?.first_name} {order.donar?.last_name}
          </Link>
        ),
        email: primaryEmail,
        created_at: order.created_at,
        order_details: (
          <ul className="list-unstyled mb-0">
            {order.order_details?.map((orderDetail, index) => (
              <li key={index}>
                {orderDetail.package?.package_title || 'Quick Donation'} |{' '}
                {orderDetail.billing_condition} |{' '}
                {orderDetail.donation_type?.donation_type_name}
              </li>
            ))}
          </ul>
        ),
        payment_method: order.payment_method?.payment_name,
        payment_status: order.payment_status,
        amount: order.donation_amount,
        id: order.id,
        simple_id: order.simple_id,
        donar_id: order.donar?.id
      };
    });
  }, [orders]);

  return (
    <CustomAdvanceTable
      data={tableData}
      columns={recentDonationsColumns}
      loading={isLoading}
      title="Recent Donations"
      pagination={{
        showInfo: false,
        showNavButtons: false,
        onClickViewAll: () => navigate(paths.allDonations)
      }}
    />
  );
};

export default RecentDonationsTable;
